import React from 'react'
import { Routes, Route, Navigate } from 'react-router-dom'
import RoleRoute from '@BUP/routes/RoleRoute'
import MySchoolPage from '@BUP/pages/MySchoolPage'
import CourseStudentPage from '@BUP/pages/MySchoolPage/Students'
import StudentsByCoursePage from '@BUP/pages/MySchoolPage/Students/studentByCourse'
import FamilesCoursesPage from '@BUP/pages/MySchoolPage/Families'
import TeacherListPage from '@BUP/pages/MySchoolPage/Teachers'
import AssistantPage from '@BUP/pages/MySchoolPage/Assistants'

const MySchoolNavigation = () => {
  return (
    <Routes>
      <Route
        path='/'
        element={
          <RoleRoute name='MySchoolPage'>
            <MySchoolPage />
          </RoleRoute>
        }
      />
      <Route
        path='studentsgrades'
        element={
          <RoleRoute name='CourseStudentPage'>
            <CourseStudentPage />
          </RoleRoute>
        }
      />
      <Route
        path='studentsgrades/courses/*'
        element={
          <RoleRoute name='StudentsByCourse'>
            <StudentsByCoursePage />
          </RoleRoute>
        }
      />
      <Route
        path='familiescourses'
        element={
          <RoleRoute name='FamilesCoursesPage'>
            <FamilesCoursesPage />
          </RoleRoute>
        }
      />
      <Route
        path='teachertablelist'
        element={
          <RoleRoute name='TeacherListPage'>
            <TeacherListPage />
          </RoleRoute>
        }
      />
      <Route
        path='asistantstablelist'
        element={
          <RoleRoute name='AssistantPage'>
            <AssistantPage />
          </RoleRoute>
        }
      />
      <Route
        path='*'
        element={<Navigate to='/' />}
      />
    </Routes>
  )
}

export default MySchoolNavigation
